import Recorder from './recorder'
export default class Record {
  startRecord (param) {
    const self = this
    try {
      Recorder.get(rec => {
        if (rec.error) return param.error(rec.error)
        self.recorder = rec
        self.recorder.start()
        param.success('开始录音')
      })
    } catch (e) {
      if (e.message === '对象不支持“getUserMedia”属性或方法') {
        param.error('当前浏览器版本不支持语音')
      } else {
        param.error('开始录音失败' + e)
      }
    }
  }

  stopRecord (param) {
    const self = this
    try {
      const blobData = self.recorder.getBlob()
      param.success(blobData)
    } catch (e) {
      if (e.message === '对象不支持“getUserMedia”属性或方法') {
        param.error('当前浏览器版本不支持语音')
      } else {
        param.error('结束录音失败' + e)
      }
    }
  }

  play (audio) {
    const self = this
    try {
      self.recorder.play(audio)
    } catch (e) {
      console.error('录音播放失败' + e)
    }
  }

  clear (audio) {
    const self = this
    try {
      self.recorder.clear(audio)
    } catch (e) {
      console.error('清空录音失败' + e)
    }
  }

  stop () {
    const self = this
    try {
      self.recorder.stop()
    } catch (e) {
      console.error('取消录音失败' + e)
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/libs/recordUtils/record-sdk.js
// module id = null
// module chunks = 